interface ToolCardTagsProps {
  tags: string[];
  onTagClick?: (tag: string) => void;
}

const ToolCardTags = ({ tags, onTagClick }: ToolCardTagsProps) => {
  return (
    <div className="flex flex-wrap gap-1.5">
      {tags.map((tag) => (
        <button
          key={tag}
          onClick={() => onTagClick?.(tag)}
          className="text-xs px-2 py-0.5 bg-purple-50 text-purple-700 rounded-full font-medium 
                   hover:bg-purple-100 hover:text-purple-800 transition-all duration-300
                   border border-purple-100/50"
        >
          #{tag}
        </button>
      ))}
    </div>
  );
};

export default ToolCardTags;